/* CANIPANI — appel a l'action collant, mobile.
   Ce code etait en ligne dans le document : il bloquait l'analyse du HTML.
   Charge en `defer`, il ne s'execute plus qu'une fois la page construite. */
(function () {
    var barre = document.querySelector('[data-sticky-cta]');
    if (!barre) return;
    var cible = document.querySelector(barre.dataset.cible || '#guide-des-tailles');

    // l'observateur est plus fiable que le calcul de rectangle : il ne dépend
    // pas d'un évènement de défilement, donc il suit aussi les sauts d'ancre
    var guideVisible = false;
    if (cible && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        guideVisible = entrees[0].isIntersecting;
        etat();
      }, { threshold: 0 }).observe(cible);
    }

    function etat() {
      var passeLePli = window.scrollY > window.innerHeight * 0.75;
      barre.dataset.visible = (passeLePli && !guideVisible) ? '1' : '0';
    }

    var enAttente = false;
    window.addEventListener('scroll', function () {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () { etat(); enAttente = false; });
    }, { passive: true });
    etat();
  })();
